import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { deleteEntity, updateEntities } from 'redux-modules/entity'

import api from 'api'

const CREATE_REQUEST = 'realhub/fonts/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/fonts/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/fonts/CREATE_FAILURE'
const DELETE_REQUEST = 'realhub/fonts/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/fonts/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/fonts/DELETE_FAILURE'
const UPDATE_REQUEST = 'realhub/fonts/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/fonts/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/fonts/UPDATE_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  creating: false,
  deleting: false,
  updating: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
    result: payload.result,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
    result: payload.result,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function createFontWeight(font, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      font,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/fonts.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().fonts.result ? getState().fonts.result.slice() : []
        if (!resultArray.includes(json.id)){
          resultArray.push(json.id)
        }

        const normalizedJson = normalize(json, Schemas.FONT)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function deleteFontWeight(fontWeight, options){
  const config = {
    method: 'DELETE',
  }
  return (dispatch, getState) => {
    // Set Loading
    dispatch(deleteRequest())
    const url = `/admin/fonts/${fontWeight.id}.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Remove from result array
        const resultArray = getState().fonts.result ? getState().fonts.result.slice() : []
        const index = resultArray.indexOf(json.id)
        if (!resultArray.includes(json.id)){
          resultArray.splice(index, 1)
        }

        const normalizedJson = normalize(json, Schemas.FONT)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

export function updateFontWeight(font, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      font,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/fonts/${font.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.FONT)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result: action.result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        result: action.result,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        result: action.result,
        errors: [],
      })
    default:
      return state
  }
}
